





















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesBase'
})
export default class extends Vue {
  get editPage() {
    const activeArr: string[] = ['FilesLabelAddEdit']
    return activeArr.includes(this.$route.name as string)
  }
}
